import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavBarService {
  
  private _triggerSplitResize: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get triggerSplitResize(): BehaviorSubject<boolean> {
    return this._triggerSplitResize;
  }
  public set triggerSplitResize(value: BehaviorSubject<boolean>) {
    this._triggerSplitResize = value;
  }

  private _isPreviewViewClosed: boolean = false;
  public get isPreviewViewClosed(): boolean {
    return this._isPreviewViewClosed;
  }
  public set isPreviewViewClosed(value: boolean) {
    this._isPreviewViewClosed = value;
  }

  private _isProjectViewClosed: boolean = false;
  public get isProjectViewClosed(): boolean {
    return this._isProjectViewClosed;
  }
  public set isProjectViewClosed(value: boolean) {
    this._isProjectViewClosed = value;
  }

  private _isCostSummaryClosed: boolean = false;
  public get isCostSummaryClosed(): boolean {
    return this._isCostSummaryClosed;
  }
  public set isCostSummaryClosed(value: boolean) {
    this._isCostSummaryClosed = value;
  }

  private _isLibraryClosed: boolean = false;
  public get isLibraryClosed(): boolean {
    return this._isLibraryClosed;
  }
  public set isLibraryClosed(value: boolean) {
    this._isLibraryClosed = value;
  }

  private _isReportViewClosed: boolean = false;
  public get isReportViewClosed(): boolean {
    return this._isReportViewClosed;
  }
  public set isReportViewClosed(value: boolean) {
    this._isReportViewClosed = value;
  }

  constructor() { }
}
